<div class="w-36 m-auto h-6 rounded-lg text-xs text-center font-bold tracking-wider uppercase py-1 {{classComponent}}" >
    <p class="">{{text}} </p>
</div>

